import { useEffect, useState } from "react";
import AgentComponent from "./AgentComponent";
import CallComponent from "./CallComponent";
import LLMComponent from "./LLMComponent";
import ToolsComponent from "./ToolsComponent";
import TranscriberComponent from "./TranscriberComponent";
import VoiceComponent from "./VoiceComponent";
import { useMediaQuery } from "react-responsive";
import EvaluationComponent from "./EvaluationComponent";
import SummaryComponent from "./SummaryComponent";
import StructuredData from "./StructuredData";

function ContentPanel({ activeTab, assistantDetail }) {
  const [agentPrompt, setAgentPrompt] = useState('');
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const isMobile = useMediaQuery({ maxWidth: 768 });


  useEffect(() => {
    const promptContent =
      assistantDetail?.model &&
      Array.isArray(assistantDetail.model.messages) &&
      assistantDetail.model.messages.length > 0 &&
      typeof assistantDetail.model.messages[0].content === 'string'
        ? assistantDetail.model.messages[0].content
        : 'This is a blank template with minimal defaults.';
    const initialMessage = assistantDetail?.firstMessage && typeof assistantDetail.firstMessage === 'string' ? assistantDetail.firstMessage : '';

    setWelcomeMessage(initialMessage);

    setAgentPrompt(promptContent);
  }, [assistantDetail]);

  const tabContentMap = {
    Agent: (
      <AgentComponent
        welcomeMessage={welcomeMessage}
        agentPrompt={agentPrompt}
      />
    ),
    LLM: (
      <LLMComponent
        provider={assistantDetail?.model?.provider || ''}
        model={assistantDetail?.model?.model || ''}
      />
    ),
    Transcriber: <TranscriberComponent />,
    Voice: <VoiceComponent />,

    Summary: <SummaryComponent/>,
    Evaluation: <EvaluationComponent/>,
    StructureData: <StructuredData/>
    
  };

  return (
    <div
    style={{
        overflowY: 'auto',
        height: isMobile ? 'auto' : '80%',
        paddingRight: isMobile ? '6px' : '10px',
        paddingLeft: isMobile ? '6px' : '10px',
      }}
    >
      {tabContentMap[activeTab] || null}
    </div>
  );
}

export default ContentPanel;
